
import { ActivitiesIcon} from "../../constants/icons"
import { msgImages } from "../../constants/images"

export const activityData = [
    {
        id: 1,
        date: "Just now",
        status: "Payment Approved",
        article:'Dr. Adebusoye withdrawal request has been approved by Vivian Aare',
        icon: ActivitiesIcon.creditGreenIcon,
    }
];



export const messaging = [
  {
    name:'Olarenwaju Saheed',
    image:msgImages.saheedImg,
    mssg:'There are many variations '
  },
  {
    name:'Cameron Williamson',
    image:msgImages.cameronImg,
    mssg:'There are many variations '
  },
  {
    name:'Leslie Alexander',
    image:msgImages.alexlieImg,
    mssg:'There are many variations '
  },
  {
    name:'Guy Hawkins',
    image:msgImages.hawkingsGImg,
    mssg:'There are many variations '
  },
  {
    name:'Jacob Jones',
    image:msgImages.jonesImg,
    mssg:'There are many variations '
  },

]